import React from 'react';
import { Outlet } from 'react-router-dom';

const KlassiTechLayout = () => {
  return (
    <div className="klassitech-layout">
      <Outlet />
    </div>
  );
};

export default KlassiTechLayout; 